const colors = {
  black: '#000000',
  white: '#FFFFFF',
  primary: {
    main: '#BB8D94',
    100: '#F6EFF0',
    150: '#F6EFF0',
    200: '#DAD0D7',
    250: '#C4B3BE',
    300: '#dcc7bd',
    500: '#BB8D94'
  },
  secondary: {
    main: '#4D5866',
    100: '#F7F7F7',
    150: '#FCF2F7',
    175: '#E7E7E8',
    200: '#E7E7E8',
    250: '#5C6A7AFF',
    300: '#4D5866',
    400: '#4D5866',
    500: '#4D5866',
    600: '#312F30',
    800: '#151717'
  },
  gray: {
    50: '#F8F7F6',
    100: '#F6F2F4',
    115: '#ECE7EB',
    125: '#E0E0E0',
    150: '#D0D0D0',
    200: '#C6C6C6',
    225: '#BFBFBF',
    230: '#919191',
    250: '#999999',
    260: '#979797',
    275: '#777777',
    300: '#666666',
    325: '#726B70',
    350: '#707070',
    375: '#5B5B5B',
    400: '#555555',
    425: '#4F4F4F',
    450: '#444444',
    500: '#404040',
    550: '#363636',
    600: '#2D2E2D',
    800: '#222222'
  },
  red: {
    100: '#FAE4E5',
    200: '#771414',
    300: '#A75348',
    400: '#C73D3D',
    500: '#E31B23',
    600: '#9D2D2D',
    700: '#B40000',
    800: '#A82026',
    900: '#A80909'
  },
  blue: {
    main: '#464DEA',
    200: '#9192A3',
    300: '#365CFF',
    400: '#6D6E71'
  },
  blackOpacity: {
    10: 'rgba(0, 0, 0, 0.1)',
    16: 'rgba(0, 0, 0, 0.16)'
  },
  whiteOpacity: {
    17: 'rgba(255, 255, 255, 0.17)',
    80: 'rgba(255, 255, 255, 0.80)'
  },
  secondaryOpacity: {
    30: 'rgba(134, 101, 122, 0.3)',
    90: 'rgba(134, 101, 122, 0.9)'
  },
  redOpacity: {
    5: 'rgba(180, 0, 0, 0.05)',
    50: 'rgba(227, 27, 35, 0.5)'
  },
  grayOpacity: {
    90: 'rgba(34, 34, 34, 0.9)'
  }
};

export default colors;
